module.exports = __webpack_public_path__ + "static/media/suspension_green.5c035c9f.png";